import { useEffect, useState } from "react";
import {
  MainCard,
  MainCardContent,
  MainCardTitle,
} from "src/components/main-card-type.tsx";
import { Button } from "src/components/ui/button";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  saveCalculatorData,
} from "src/utils/functions";
import type { ResultsType } from "../calculadora-custos-fixos_d";
import {
  calcularCustosFixos,
  formatBrlInput,
  sanitizeBrlValue,
} from "../utils/functions";

const calculatorKey = "custos-fixos";

const Tooltip = ({
  children,
  text,
}: {
  children: React.ReactNode;
  text: string;
}) => (
  <div className="relative inline-block group">
    {children}
    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-4 py-3 w-64 text-sm text-white bg-gray-800 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-normal z-20 pointer-events-none shadow-lg">
      {text}
      <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
        <div className="border-8 border-transparent border-t-gray-800"></div>
      </div>
    </div>
  </div>
);

export const CustosFixosInputCard = ({
  setResults,
}: {
  setResults: (value: ResultsType | null) => void;
}) => {
  const [message, setMessage] = useState<string>("");

  // Renda
  const [rendaLiquida, setRendaLiquida] = useState("");

  // MORADIA
  const [moradiaAluguel, setMoradiaAluguel] = useState("");
  const [moradiaCondominio, setMoradiaCondominio] = useState("");
  const [moradiaAgua, setMoradiaAgua] = useState("");
  const [moradiaLuz, setMoradiaLuz] = useState("");
  const [moradiaInternet, setMoradiaInternet] = useState("");
  const [moradiaGas, setMoradiaGas] = useState("");
  const [moradiaGasFreq, setMoradiaGasFreq] = useState(2);

  const [moradiaOutrosVisiveis, setMoradiaOutrosVisiveis] = useState(0);
  const [moradiaOutros1Desc, setMoradiaOutros1Desc] = useState("");
  const [moradiaOutros1Valor, setMoradiaOutros1Valor] = useState("");
  const [moradiaOutros1Freq, setMoradiaOutros1Freq] = useState(1);
  const [moradiaOutros2Desc, setMoradiaOutros2Desc] = useState("");
  const [moradiaOutros2Valor, setMoradiaOutros2Valor] = useState("");
  const [moradiaOutros2Freq, setMoradiaOutros2Freq] = useState(1);

  // TRANSPORTE
  const [transportePrestacao, setTransportePrestacao] = useState("");
  const [transporteCombustivel, setTransporteCombustivel] = useState("");
  const [transporteEstacionamento, setTransporteEstacionamento] = useState("");
  const [transportePublico, setTransportePublico] = useState("");
  const [transporteIpva, setTransporteIpva] = useState("");
  const [transporteSeguro, setTransporteSeguro] = useState("");
  const [transporteLicenciamento, setTransporteLicenciamento] = useState("");

  const [transporteOutrosVisiveis, setTransporteOutrosVisiveis] = useState(0);
  const [transporteOutros1Desc, setTransporteOutros1Desc] = useState("");
  const [transporteOutros1Valor, setTransporteOutros1Valor] = useState("");
  const [transporteOutros1Freq, setTransporteOutros1Freq] = useState(1);
  const [transporteOutros2Desc, setTransporteOutros2Desc] = useState("");
  const [transporteOutros2Valor, setTransporteOutros2Valor] = useState("");
  const [transporteOutros2Freq, setTransporteOutros2Freq] = useState(1);

  // SAÚDE & BEM-ESTAR
  const [saudePlano, setSaudePlano] = useState("");
  const [saudeAcademia, setSaudeAcademia] = useState("");
  const [saudeMedicamentos, setSaudeMedicamentos] = useState("");

  const [saudeOutrosVisiveis, setSaudeOutrosVisiveis] = useState(0);
  const [saudeOutros1Desc, setSaudeOutros1Desc] = useState("");
  const [saudeOutros1Valor, setSaudeOutros1Valor] = useState("");
  const [saudeOutros1Freq, setSaudeOutros1Freq] = useState(1);
  const [saudeOutros2Desc, setSaudeOutros2Desc] = useState("");
  const [saudeOutros2Valor, setSaudeOutros2Valor] = useState("");
  const [saudeOutros2Freq, setSaudeOutros2Freq] = useState(1);

  // ALIMENTAÇÃO
  const [alimentacaoSupermercado, setAlimentacaoSupermercado] = useState("");
  const [alimentacaoDelivery, setAlimentacaoDelivery] = useState("");
  const [alimentacaoFeira, setAlimentacaoFeira] = useState("");

  const [alimentacaoOutrosVisiveis, setAlimentacaoOutrosVisiveis] = useState(0);
  const [alimentacaoOutros1Desc, setAlimentacaoOutros1Desc] = useState("");
  const [alimentacaoOutros1Valor, setAlimentacaoOutros1Valor] = useState("");
  const [alimentacaoOutros1Freq, setAlimentacaoOutros1Freq] = useState(1);

  // ESTILO DE VIDA
  const [estiloCelular, setEstiloCelular] = useState("");
  const [estiloStreaming, setEstiloStreaming] = useState("");
  const [estiloEducacaoFilhos, setEstiloEducacaoFilhos] = useState("");
  const [estiloPets, setEstiloPets] = useState("");
  const [estiloFaxina, setEstiloFaxina] = useState("");
  const [estiloJardinagem, setEstiloJardinagem] = useState("");
  const [estiloSalao, setEstiloSalao] = useState("");
  const [estiloProdutos, setEstiloProdutos] = useState("");

  const [estiloOutrosVisiveis, setEstiloOutrosVisiveis] = useState(0);
  const [estiloOutros1Desc, setEstiloOutros1Desc] = useState("");
  const [estiloOutros1Valor, setEstiloOutros1Valor] = useState("");
  const [estiloOutros1Freq, setEstiloOutros1Freq] = useState(1);
  const [estiloOutros2Desc, setEstiloOutros2Desc] = useState("");
  const [estiloOutros2Valor, setEstiloOutros2Valor] = useState("");
  const [estiloOutros2Freq, setEstiloOutros2Freq] = useState(1);
  const [estiloOutros3Desc, setEstiloOutros3Desc] = useState("");
  const [estiloOutros3Valor, setEstiloOutros3Valor] = useState("");
  const [estiloOutros3Freq, setEstiloOutros3Freq] = useState(1);

  function clear() {
    setRendaLiquida("");

    // Moradia
    setMoradiaAluguel("");
    setMoradiaCondominio("");
    setMoradiaAgua("");
    setMoradiaLuz("");
    setMoradiaInternet("");
    setMoradiaGas("");
    setMoradiaGasFreq(2);
    setMoradiaOutrosVisiveis(0);
    setMoradiaOutros1Desc("");
    setMoradiaOutros1Valor("");
    setMoradiaOutros1Freq(1);
    setMoradiaOutros2Desc("");
    setMoradiaOutros2Valor("");
    setMoradiaOutros2Freq(1);

    // Transporte
    setTransportePrestacao("");
    setTransporteCombustivel("");
    setTransporteEstacionamento("");
    setTransportePublico("");
    setTransporteIpva("");
    setTransporteSeguro("");
    setTransporteLicenciamento("");
    setTransporteOutrosVisiveis(0);
    setTransporteOutros1Desc("");
    setTransporteOutros1Valor("");
    setTransporteOutros1Freq(1);
    setTransporteOutros2Desc("");
    setTransporteOutros2Valor("");
    setTransporteOutros2Freq(1);

    // Saúde
    setSaudePlano("");
    setSaudeAcademia("");
    setSaudeMedicamentos("");
    setSaudeOutrosVisiveis(0);
    setSaudeOutros1Desc("");
    setSaudeOutros1Valor("");
    setSaudeOutros1Freq(1);
    setSaudeOutros2Desc("");
    setSaudeOutros2Valor("");
    setSaudeOutros2Freq(1);

    // Alimentação
    setAlimentacaoSupermercado("");
    setAlimentacaoDelivery("");
    setAlimentacaoFeira("");
    setAlimentacaoOutrosVisiveis(0);
    setAlimentacaoOutros1Desc("");
    setAlimentacaoOutros1Valor("");
    setAlimentacaoOutros1Freq(1);

    // Estilo de Vida
    setEstiloCelular("");
    setEstiloStreaming("");
    setEstiloEducacaoFilhos("");
    setEstiloPets("");
    setEstiloFaxina("");
    setEstiloJardinagem("");
    setEstiloSalao("");
    setEstiloProdutos("");
    setEstiloOutrosVisiveis(0);
    setEstiloOutros1Desc("");
    setEstiloOutros1Valor("");
    setEstiloOutros1Freq(1);
    setEstiloOutros2Desc("");
    setEstiloOutros2Valor("");
    setEstiloOutros2Freq(1);
    setEstiloOutros3Desc("");
    setEstiloOutros3Valor("");
    setEstiloOutros3Freq(1);

    setResults(null);
    setMessage("");
  }

  function validarCampos(): boolean {
    const renda = sanitizeBrlValue(rendaLiquida);

    if (!rendaLiquida || renda <= 0) {
      setMessage("Informe sua renda líquida mensal.");
      return false;
    }

    if (renda < 500) {
      setMessage("Renda líquida deve ser maior que R$ 500,00.");
      return false;
    }

    // Verificar se tem pelo menos um gasto informado
    const temAlgumGasto =
      moradiaAluguel ||
      moradiaCondominio ||
      moradiaAgua ||
      moradiaLuz ||
      moradiaInternet ||
      moradiaGas ||
      transportePrestacao ||
      transporteCombustivel ||
      transporteEstacionamento ||
      transportePublico ||
      transporteIpva ||
      transporteSeguro ||
      transporteLicenciamento ||
      saudePlano ||
      saudeAcademia ||
      saudeMedicamentos ||
      alimentacaoSupermercado ||
      alimentacaoDelivery ||
      alimentacaoFeira ||
      estiloCelular ||
      estiloStreaming ||
      estiloEducacaoFilhos ||
      estiloPets ||
      estiloFaxina ||
      estiloJardinagem ||
      estiloSalao ||
      estiloProdutos;

    if (!temAlgumGasto) {
      setMessage("Informe ao menos um gasto fixo para calcular.");
      return false;
    }

    // Validar campos personalizados (se tem descrição, deve ter valor)
    if (moradiaOutros1Desc && !moradiaOutros1Valor) {
      setMessage("Informe o valor do gasto personalizado de Moradia.");
      return false;
    }
    if (moradiaOutros1Valor && !moradiaOutros1Desc) {
      setMessage("Informe a descrição do gasto personalizado de Moradia.");
      return false;
    }
    if (moradiaOutros2Desc && !moradiaOutros2Valor) {
      setMessage("Informe o valor do segundo gasto personalizado de Moradia.");
      return false;
    }
    if (moradiaOutros2Valor && !moradiaOutros2Desc) {
      setMessage(
        "Informe a descrição do segundo gasto personalizado de Moradia.",
      );
      return false;
    }

    // Validações similares para outras categorias
    if (transporteOutros1Desc && !transporteOutros1Valor) {
      setMessage("Informe o valor do gasto personalizado de Transporte.");
      return false;
    }
    if (transporteOutros1Valor && !transporteOutros1Desc) {
      setMessage("Informe a descrição do gasto personalizado de Transporte.");
      return false;
    }

    if (saudeOutros1Desc && !saudeOutros1Valor) {
      setMessage("Informe o valor do gasto personalizado de Saúde.");
      return false;
    }
    if (saudeOutros1Valor && !saudeOutros1Desc) {
      setMessage("Informe a descrição do gasto personalizado de Saúde.");
      return false;
    }

    if (alimentacaoOutros1Desc && !alimentacaoOutros1Valor) {
      setMessage("Informe o valor do gasto personalizado de Alimentação.");
      return false;
    }
    if (alimentacaoOutros1Valor && !alimentacaoOutros1Desc) {
      setMessage("Informe a descrição do gasto personalizado de Alimentação.");
      return false;
    }

    if (estiloOutros1Desc && !estiloOutros1Valor) {
      setMessage("Informe o valor do gasto personalizado de Estilo de Vida.");
      return false;
    }
    if (estiloOutros1Valor && !estiloOutros1Desc) {
      setMessage(
        "Informe a descrição do gasto personalizado de Estilo de Vida.",
      );
      return false;
    }

    return true;
  }

  function calcular() {
    if (!validarCampos()) return;

    const renda = sanitizeBrlValue(rendaLiquida);

    // Montar arrays de gastos por categoria
    const moradia = [
      {
        descricao: "Aluguel/Financiamento",
        valor: sanitizeBrlValue(moradiaAluguel),
        frequencia: 1,
      },
      {
        descricao: "Condomínio",
        valor: sanitizeBrlValue(moradiaCondominio),
        frequencia: 1,
      },
      {
        descricao: "Água",
        valor: sanitizeBrlValue(moradiaAgua),
        frequencia: 1,
      },
      { descricao: "Luz", valor: sanitizeBrlValue(moradiaLuz), frequencia: 1 },
      {
        descricao: "Internet",
        valor: sanitizeBrlValue(moradiaInternet),
        frequencia: 1,
      },
      {
        descricao: "Gás",
        valor: sanitizeBrlValue(moradiaGas),
        frequencia: moradiaGasFreq,
      },
      {
        descricao: moradiaOutros1Desc,
        valor: sanitizeBrlValue(moradiaOutros1Valor),
        frequencia: moradiaOutros1Freq,
      },
      {
        descricao: moradiaOutros2Desc,
        valor: sanitizeBrlValue(moradiaOutros2Valor),
        frequencia: moradiaOutros2Freq,
      },
    ];

    const transporte = [
      {
        descricao: "Prestação do veículo",
        valor: sanitizeBrlValue(transportePrestacao),
        frequencia: 1,
      },
      {
        descricao: "Combustível",
        valor: sanitizeBrlValue(transporteCombustivel),
        frequencia: 1,
      },
      {
        descricao: "Estacionamento",
        valor: sanitizeBrlValue(transporteEstacionamento),
        frequencia: 1,
      },
      {
        descricao: "Transporte público",
        valor: sanitizeBrlValue(transportePublico),
        frequencia: 1,
      },
      {
        descricao: "IPVA",
        valor: sanitizeBrlValue(transporteIpva),
        frequencia: 12,
      },
      {
        descricao: "Seguro",
        valor: sanitizeBrlValue(transporteSeguro),
        frequencia: 12,
      },
      {
        descricao: "Licenciamento",
        valor: sanitizeBrlValue(transporteLicenciamento),
        frequencia: 12,
      },
      {
        descricao: transporteOutros1Desc,
        valor: sanitizeBrlValue(transporteOutros1Valor),
        frequencia: transporteOutros1Freq,
      },
      {
        descricao: transporteOutros2Desc,
        valor: sanitizeBrlValue(transporteOutros2Valor),
        frequencia: transporteOutros2Freq,
      },
    ];

    const saude = [
      {
        descricao: "Plano de saúde",
        valor: sanitizeBrlValue(saudePlano),
        frequencia: 1,
      },
      {
        descricao: "Academia",
        valor: sanitizeBrlValue(saudeAcademia),
        frequencia: 1,
      },
      {
        descricao: "Medicamentos",
        valor: sanitizeBrlValue(saudeMedicamentos),
        frequencia: 1,
      },
      {
        descricao: saudeOutros1Desc,
        valor: sanitizeBrlValue(saudeOutros1Valor),
        frequencia: saudeOutros1Freq,
      },
      {
        descricao: saudeOutros2Desc,
        valor: sanitizeBrlValue(saudeOutros2Valor),
        frequencia: saudeOutros2Freq,
      },
    ];

    const alimentacao = [
      {
        descricao: "Supermercado",
        valor: sanitizeBrlValue(alimentacaoSupermercado),
        frequencia: 1,
      },
      {
        descricao: "Delivery/Restaurantes",
        valor: sanitizeBrlValue(alimentacaoDelivery),
        frequencia: 1,
      },
      {
        descricao: "Feira/Açougue",
        valor: sanitizeBrlValue(alimentacaoFeira),
        frequencia: 1,
      },
      {
        descricao: alimentacaoOutros1Desc,
        valor: sanitizeBrlValue(alimentacaoOutros1Valor),
        frequencia: alimentacaoOutros1Freq,
      },
    ];

    const estiloVida = [
      {
        descricao: "Celular/Telefonia",
        valor: sanitizeBrlValue(estiloCelular),
        frequencia: 1,
      },
      {
        descricao: "Streaming",
        valor: sanitizeBrlValue(estiloStreaming),
        frequencia: 1,
      },
      {
        descricao: "Educação dos filhos",
        valor: sanitizeBrlValue(estiloEducacaoFilhos),
        frequencia: 1,
      },
      { descricao: "Pets", valor: sanitizeBrlValue(estiloPets), frequencia: 1 },
      {
        descricao: "Faxina/Diarista",
        valor: sanitizeBrlValue(estiloFaxina),
        frequencia: 1,
      },
      {
        descricao: "Jardinagem/Piscina",
        valor: sanitizeBrlValue(estiloJardinagem),
        frequencia: 1,
      },
      {
        descricao: "Salão/Barbearia",
        valor: sanitizeBrlValue(estiloSalao),
        frequencia: 1,
      },
      {
        descricao: "Produtos de higiene",
        valor: sanitizeBrlValue(estiloProdutos),
        frequencia: 1,
      },
      {
        descricao: estiloOutros1Desc,
        valor: sanitizeBrlValue(estiloOutros1Valor),
        frequencia: estiloOutros1Freq,
      },
      {
        descricao: estiloOutros2Desc,
        valor: sanitizeBrlValue(estiloOutros2Valor),
        frequencia: estiloOutros2Freq,
      },
      {
        descricao: estiloOutros3Desc,
        valor: sanitizeBrlValue(estiloOutros3Valor),
        frequencia: estiloOutros3Freq,
      },
    ];

    const results = calcularCustosFixos({
      rendaLiquida: renda,
      moradia,
      transporte,
      saude,
      alimentacao,
      estiloVida,
    });

    setResults(results);
    setMessage("");
  }

  function handleSave() {
    saveCalculatorData(calculatorKey, {
      rendaLiquida,
      moradiaAluguel,
      moradiaCondominio,
      moradiaAgua,
      moradiaLuz,
      moradiaInternet,
      moradiaGas,
      moradiaGasFreq,
      moradiaOutrosVisiveis,
      moradiaOutros1Desc,
      moradiaOutros1Valor,
      moradiaOutros1Freq,
      moradiaOutros2Desc,
      moradiaOutros2Valor,
      moradiaOutros2Freq,
      transportePrestacao,
      transporteCombustivel,
      transporteEstacionamento,
      transportePublico,
      transporteIpva,
      transporteSeguro,
      transporteLicenciamento,
      transporteOutrosVisiveis,
      transporteOutros1Desc,
      transporteOutros1Valor,
      transporteOutros1Freq,
      transporteOutros2Desc,
      transporteOutros2Valor,
      transporteOutros2Freq,
      saudePlano,
      saudeAcademia,
      saudeMedicamentos,
      saudeOutrosVisiveis,
      saudeOutros1Desc,
      saudeOutros1Valor,
      saudeOutros1Freq,
      saudeOutros2Desc,
      saudeOutros2Valor,
      saudeOutros2Freq,
      alimentacaoSupermercado,
      alimentacaoDelivery,
      alimentacaoFeira,
      alimentacaoOutrosVisiveis,
      alimentacaoOutros1Desc,
      alimentacaoOutros1Valor,
      alimentacaoOutros1Freq,
      estiloCelular,
      estiloStreaming,
      estiloEducacaoFilhos,
      estiloPets,
      estiloFaxina,
      estiloJardinagem,
      estiloSalao,
      estiloProdutos,
      estiloOutrosVisiveis,
      estiloOutros1Desc,
      estiloOutros1Valor,
      estiloOutros1Freq,
      estiloOutros2Desc,
      estiloOutros2Valor,
      estiloOutros2Freq,
      estiloOutros3Desc,
      estiloOutros3Valor,
      estiloOutros3Freq,
    });
  }

  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;

    setRendaLiquida((savedData.rendaLiquida as string) || "");
    setMoradiaAluguel((savedData.moradiaAluguel as string) || "");
    setMoradiaCondominio((savedData.moradiaCondominio as string) || "");
    setMoradiaAgua((savedData.moradiaAgua as string) || "");
    setMoradiaLuz((savedData.moradiaLuz as string) || "");
    setMoradiaInternet((savedData.moradiaInternet as string) || "");
    setMoradiaGas((savedData.moradiaGas as string) || "");
    setMoradiaGasFreq((savedData.moradiaGasFreq as number) || 2);
    setMoradiaOutrosVisiveis((savedData.moradiaOutrosVisiveis as number) || 0);
    setMoradiaOutros1Desc((savedData.moradiaOutros1Desc as string) || "");
    setMoradiaOutros1Valor((savedData.moradiaOutros1Valor as string) || "");
    setMoradiaOutros1Freq((savedData.moradiaOutros1Freq as number) || 1);
    setMoradiaOutros2Desc((savedData.moradiaOutros2Desc as string) || "");
    setMoradiaOutros2Valor((savedData.moradiaOutros2Valor as string) || "");
    setMoradiaOutros2Freq((savedData.moradiaOutros2Freq as number) || 1);

    setTransportePrestacao((savedData.transportePrestacao as string) || "");
    setTransporteCombustivel((savedData.transporteCombustivel as string) || "");
    setTransporteEstacionamento(
      (savedData.transporteEstacionamento as string) || "",
    );
    setTransportePublico((savedData.transportePublico as string) || "");
    setTransporteIpva((savedData.transporteIpva as string) || "");
    setTransporteSeguro((savedData.transporteSeguro as string) || "");
    setTransporteLicenciamento(
      (savedData.transporteLicenciamento as string) || "",
    );
    setTransporteOutrosVisiveis(
      (savedData.transporteOutrosVisiveis as number) || 0,
    );
    setTransporteOutros1Desc((savedData.transporteOutros1Desc as string) || "");
    setTransporteOutros1Valor(
      (savedData.transporteOutros1Valor as string) || "",
    );
    setTransporteOutros1Freq((savedData.transporteOutros1Freq as number) || 1);
    setTransporteOutros2Desc((savedData.transporteOutros2Desc as string) || "");
    setTransporteOutros2Valor(
      (savedData.transporteOutros2Valor as string) || "",
    );
    setTransporteOutros2Freq((savedData.transporteOutros2Freq as number) || 1);

    setSaudePlano((savedData.saudePlano as string) || "");
    setSaudeAcademia((savedData.saudeAcademia as string) || "");
    setSaudeMedicamentos((savedData.saudeMedicamentos as string) || "");
    setSaudeOutrosVisiveis((savedData.saudeOutrosVisiveis as number) || 0);
    setSaudeOutros1Desc((savedData.saudeOutros1Desc as string) || "");
    setSaudeOutros1Valor((savedData.saudeOutros1Valor as string) || "");
    setSaudeOutros1Freq((savedData.saudeOutros1Freq as number) || 1);
    setSaudeOutros2Desc((savedData.saudeOutros2Desc as string) || "");
    setSaudeOutros2Valor((savedData.saudeOutros2Valor as string) || "");
    setSaudeOutros2Freq((savedData.saudeOutros2Freq as number) || 1);

    setAlimentacaoSupermercado(
      (savedData.alimentacaoSupermercado as string) || "",
    );
    setAlimentacaoDelivery((savedData.alimentacaoDelivery as string) || "");
    setAlimentacaoFeira((savedData.alimentacaoFeira as string) || "");
    setAlimentacaoOutrosVisiveis(
      (savedData.alimentacaoOutrosVisiveis as number) || 0,
    );
    setAlimentacaoOutros1Desc(
      (savedData.alimentacaoOutros1Desc as string) || "",
    );
    setAlimentacaoOutros1Valor(
      (savedData.alimentacaoOutros1Valor as string) || "",
    );
    setAlimentacaoOutros1Freq(
      (savedData.alimentacaoOutros1Freq as number) || 1,
    );

    setEstiloCelular((savedData.estiloCelular as string) || "");
    setEstiloStreaming((savedData.estiloStreaming as string) || "");
    setEstiloEducacaoFilhos((savedData.estiloEducacaoFilhos as string) || "");
    setEstiloPets((savedData.estiloPets as string) || "");
    setEstiloFaxina((savedData.estiloFaxina as string) || "");
    setEstiloJardinagem((savedData.estiloJardinagem as string) || "");
    setEstiloSalao((savedData.estiloSalao as string) || "");
    setEstiloProdutos((savedData.estiloProdutos as string) || "");
    setEstiloOutrosVisiveis((savedData.estiloOutrosVisiveis as number) || 0);
    setEstiloOutros1Desc((savedData.estiloOutros1Desc as string) || "");
    setEstiloOutros1Valor((savedData.estiloOutros1Valor as string) || "");
    setEstiloOutros1Freq((savedData.estiloOutros1Freq as number) || 1);
    setEstiloOutros2Desc((savedData.estiloOutros2Desc as string) || "");
    setEstiloOutros2Valor((savedData.estiloOutros2Valor as string) || "");
    setEstiloOutros2Freq((savedData.estiloOutros2Freq as number) || 1);
    setEstiloOutros3Desc((savedData.estiloOutros3Desc as string) || "");
    setEstiloOutros3Valor((savedData.estiloOutros3Valor as string) || "");
    setEstiloOutros3Freq((savedData.estiloOutros3Freq as number) || 1);
  }, []);

  return (
    <MainCard>
      <MainCardTitle className="mb-4">
        Calculadora de Custos Fixos
      </MainCardTitle>
      <form
        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular);
        }}
      >
        <MainCardContent>
          {/* RENDA LÍQUIDA */}
          <div className="col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="renda-liquida"
            >
              <Tooltip text="Valor que você recebe na conta após descontos de impostos e INSS">
                <span className="cursor-help border-b border-dotted border-gray-400">
                  Renda líquida mensal
                </span>
              </Tooltip>
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="renda-liquida"
                placeholder="5.000,00"
                type="text"
                value={rendaLiquida}
                onChange={(e) =>
                  setRendaLiquida(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          {/* CATEGORIA: MORADIA */}
          <div className="col-span-2 mt-6 mb-3">
            <h3 className="font-semibold text-lg text-primary flex items-center">
              Moradia
              <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-1 rounded font-normal">
                Essencial
              </span>
            </h3>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-aluguel"
            >
              Aluguel/Financiamento
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="moradia-aluguel"
                placeholder="1.500,00"
                type="text"
                value={moradiaAluguel}
                onChange={(e) =>
                  setMoradiaAluguel(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-condominio"
            >
              Condomínio
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="moradia-condominio"
                placeholder="400,00"
                type="text"
                value={moradiaCondominio}
                onChange={(e) =>
                  setMoradiaCondominio(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-agua"
            >
              Água
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="moradia-agua"
                placeholder="80,00"
                type="text"
                value={moradiaAgua}
                onChange={(e) => setMoradiaAgua(formatBrlInput(e.target.value))}
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-luz"
            >
              Luz
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="moradia-luz"
                placeholder="180,00"
                type="text"
                value={moradiaLuz}
                onChange={(e) => setMoradiaLuz(formatBrlInput(e.target.value))}
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-internet"
            >
              Internet
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="moradia-internet"
                placeholder="100,00"
                type="text"
                value={moradiaInternet}
                onChange={(e) =>
                  setMoradiaInternet(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="moradia-gas"
            >
              Gás de cozinha
            </label>
            <div className="flex gap-2">
              <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                  R$
                </span>
                <input
                  className="flex-1 p-2 min-w-[60px]"
                  id="moradia-gas"
                  placeholder="120,00"
                  type="text"
                  value={moradiaGas}
                  onChange={(e) =>
                    setMoradiaGas(formatBrlInput(e.target.value))
                  }
                />
              </div>
              <select
                className="border p-2 rounded text-sm bg-white min-w-[140px]"
                value={moradiaGasFreq}
                onChange={(e) => setMoradiaGasFreq(Number(e.target.value))}
              >
                <option value="1">Mensal</option>
                <option value="2">A cada 2 meses</option>
                <option value="3">A cada 3 meses</option>
                <option value="6">A cada 6 meses</option>
              </select>
            </div>
            {moradiaGas && sanitizeBrlValue(moradiaGas) > 0 && (
              <p className="text-xs text-gray-600 mt-1">
                → R${" "}
                {(sanitizeBrlValue(moradiaGas) / moradiaGasFreq)
                  .toFixed(2)
                  .replace(".", ",")}{" "}
                por mês
              </p>
            )}
          </div>

          {/* Campos personalizados Moradia */}
          {moradiaOutrosVisiveis >= 1 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-3 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setMoradiaOutros1Desc("");
                    setMoradiaOutros1Valor("");
                    setMoradiaOutros1Freq(1);
                    setMoradiaOutrosVisiveis(0);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: IPTU mensal"
                  type="text"
                  value={moradiaOutros1Desc}
                  onChange={(e) => setMoradiaOutros1Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">Valor</label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="200,00"
                      type="text"
                      value={moradiaOutros1Valor}
                      onChange={(e) =>
                        setMoradiaOutros1Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={moradiaOutros1Freq}
                    onChange={(e) =>
                      setMoradiaOutros1Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {moradiaOutros1Valor &&
                  sanitizeBrlValue(moradiaOutros1Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(moradiaOutros1Valor) /
                        moradiaOutros1Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          {moradiaOutrosVisiveis >= 2 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-4 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado 2
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setMoradiaOutros2Desc("");
                    setMoradiaOutros2Valor("");
                    setMoradiaOutros2Freq(1);
                    setMoradiaOutrosVisiveis(1);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Seguro residencial"
                  type="text"
                  value={moradiaOutros2Desc}
                  onChange={(e) => setMoradiaOutros2Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Valor (2)
                </label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="150,00"
                      type="text"
                      value={moradiaOutros2Valor}
                      onChange={(e) =>
                        setMoradiaOutros2Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={moradiaOutros2Freq}
                    onChange={(e) =>
                      setMoradiaOutros2Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {moradiaOutros2Valor &&
                  sanitizeBrlValue(moradiaOutros2Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(moradiaOutros2Valor) /
                        moradiaOutros2Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          <div className="col-span-2">
            <button
              type="button"
              onClick={() =>
                setMoradiaOutrosVisiveis((prev) => Math.min(prev + 1, 2))
              }
              className="text-primary text-sm hover:underline disabled:text-gray-400 disabled:no-underline"
              disabled={moradiaOutrosVisiveis >= 2}
            >
              + Adicionar outro gasto de moradia
            </button>
          </div>

          {/* CATEGORIA: TRANSPORTE */}
          <div className="col-span-2 mt-6 mb-3 border-t pt-6">
            <h3 className="font-semibold text-lg text-primary flex items-center">
              Transporte
              <span className="ml-2 text-xs bg-gray-100 text-gray-800 px-2 py-1 rounded font-normal">
                Misto
              </span>
            </h3>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-prestacao"
            >
              Prestação do veículo
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-prestacao"
                placeholder="800,00"
                type="text"
                value={transportePrestacao}
                onChange={(e) =>
                  setTransportePrestacao(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-combustivel"
            >
              <Tooltip text="Média mensal. Se varia, use a média dos últimos 3 meses">
                <span className="cursor-help border-b border-dotted border-gray-400">
                  Combustível
                </span>
              </Tooltip>
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-combustivel"
                placeholder="400,00"
                type="text"
                value={transporteCombustivel}
                onChange={(e) =>
                  setTransporteCombustivel(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-estacionamento"
            >
              Estacionamento
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-estacionamento"
                placeholder="300,00"
                type="text"
                value={transporteEstacionamento}
                onChange={(e) =>
                  setTransporteEstacionamento(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-publico"
            >
              Transporte público/Apps
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-publico"
                placeholder="200,00"
                type="text"
                value={transportePublico}
                onChange={(e) =>
                  setTransportePublico(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="col-span-2 mt-3 mb-2">
            <p className="text-sm text-gray-600 font-medium">
              Gastos anualizados (convertidos automaticamente para mensal):
            </p>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-ipva"
            >
              <Tooltip text="Digite o valor anual. Calculamos o impacto mensal automaticamente">
                <span className="cursor-help border-b border-dotted border-gray-400">
                  IPVA (valor anual)
                </span>
              </Tooltip>
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-ipva"
                placeholder="1.200,00"
                type="text"
                value={transporteIpva}
                onChange={(e) =>
                  setTransporteIpva(formatBrlInput(e.target.value))
                }
              />
            </div>
            {transporteIpva && sanitizeBrlValue(transporteIpva) > 0 && (
              <p className="text-xs text-gray-600 mt-1">
                → R${" "}
                {(sanitizeBrlValue(transporteIpva) / 12)
                  .toFixed(2)
                  .replace(".", ",")}{" "}
                por mês
              </p>
            )}
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-seguro"
            >
              Seguro do veículo (valor anual)
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-seguro"
                placeholder="1.800,00"
                type="text"
                value={transporteSeguro}
                onChange={(e) =>
                  setTransporteSeguro(formatBrlInput(e.target.value))
                }
              />
            </div>
            {transporteSeguro && sanitizeBrlValue(transporteSeguro) > 0 && (
              <p className="text-xs text-gray-600 mt-1">
                → R${" "}
                {(sanitizeBrlValue(transporteSeguro) / 12)
                  .toFixed(2)
                  .replace(".", ",")}{" "}
                por mês
              </p>
            )}
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="transporte-licenciamento"
            >
              Licenciamento (valor anual)
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="transporte-licenciamento"
                placeholder="200,00"
                type="text"
                value={transporteLicenciamento}
                onChange={(e) =>
                  setTransporteLicenciamento(formatBrlInput(e.target.value))
                }
              />
            </div>
            {transporteLicenciamento &&
              sanitizeBrlValue(transporteLicenciamento) > 0 && (
                <p className="text-xs text-gray-600 mt-1">
                  → R${" "}
                  {(sanitizeBrlValue(transporteLicenciamento) / 12)
                    .toFixed(2)
                    .replace(".", ",")}{" "}
                  por mês
                </p>
              )}
          </div>

          {/* Campos personalizados Transporte */}
          {transporteOutrosVisiveis >= 1 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-3 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setTransporteOutros1Desc("");
                    setTransporteOutros1Valor("");
                    setTransporteOutros1Freq(1);
                    setTransporteOutrosVisiveis(0);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Revisão do carro"
                  type="text"
                  value={transporteOutros1Desc}
                  onChange={(e) => setTransporteOutros1Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">Valor</label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="600,00"
                      type="text"
                      value={transporteOutros1Valor}
                      onChange={(e) =>
                        setTransporteOutros1Valor(
                          formatBrlInput(e.target.value),
                        )
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={transporteOutros1Freq}
                    onChange={(e) =>
                      setTransporteOutros1Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {transporteOutros1Valor &&
                  sanitizeBrlValue(transporteOutros1Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(transporteOutros1Valor) /
                        transporteOutros1Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          {transporteOutrosVisiveis >= 2 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-4 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado 2
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setTransporteOutros2Desc("");
                    setTransporteOutros2Valor("");
                    setTransporteOutros2Freq(1);
                    setTransporteOutrosVisiveis(1);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Manutenção preventiva"
                  type="text"
                  value={transporteOutros2Desc}
                  onChange={(e) => setTransporteOutros2Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Valor (2)
                </label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="400,00"
                      type="text"
                      value={transporteOutros2Valor}
                      onChange={(e) =>
                        setTransporteOutros2Valor(
                          formatBrlInput(e.target.value),
                        )
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={transporteOutros2Freq}
                    onChange={(e) =>
                      setTransporteOutros2Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {transporteOutros2Valor &&
                  sanitizeBrlValue(transporteOutros2Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(transporteOutros2Valor) /
                        transporteOutros2Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          <div className="col-span-2">
            <button
              type="button"
              onClick={() =>
                setTransporteOutrosVisiveis((prev) => Math.min(prev + 1, 2))
              }
              className="text-primary text-sm hover:underline disabled:text-gray-400 disabled:no-underline"
              disabled={transporteOutrosVisiveis >= 2}
            >
              + Adicionar outro gasto de transporte
            </button>
          </div>

          {/* CATEGORIA: SAÚDE & BEM-ESTAR */}
          <div className="col-span-2 mt-6 mb-3 border-t pt-6">
            <h3 className="font-semibold text-lg text-primary flex items-center">
              Saúde & Bem-estar
              <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-1 rounded font-normal">
                Essencial
              </span>
            </h3>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="saude-plano"
            >
              Plano de saúde
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="saude-plano"
                placeholder="450,00"
                type="text"
                value={saudePlano}
                onChange={(e) => setSaudePlano(formatBrlInput(e.target.value))}
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="saude-academia"
            >
              Academia/Atividade física
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="saude-academia"
                placeholder="100,00"
                type="text"
                value={saudeAcademia}
                onChange={(e) =>
                  setSaudeAcademia(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="saude-medicamentos"
            >
              Medicamentos contínuos
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="saude-medicamentos"
                placeholder="150,00"
                type="text"
                value={saudeMedicamentos}
                onChange={(e) =>
                  setSaudeMedicamentos(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          {/* Campos personalizados Saúde */}
          {saudeOutrosVisiveis >= 1 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-3 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setSaudeOutros1Desc("");
                    setSaudeOutros1Valor("");
                    setSaudeOutros1Freq(1);
                    setSaudeOutrosVisiveis(0);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Terapia"
                  type="text"
                  value={saudeOutros1Desc}
                  onChange={(e) => setSaudeOutros1Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">Valor</label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="200,00"
                      type="text"
                      value={saudeOutros1Valor}
                      onChange={(e) =>
                        setSaudeOutros1Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={saudeOutros1Freq}
                    onChange={(e) =>
                      setSaudeOutros1Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {saudeOutros1Valor &&
                  sanitizeBrlValue(saudeOutros1Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(sanitizeBrlValue(saudeOutros1Valor) / saudeOutros1Freq)
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          {saudeOutrosVisiveis >= 2 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-4 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado 2
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setSaudeOutros2Desc("");
                    setSaudeOutros2Valor("");
                    setSaudeOutros2Freq(1);
                    setSaudeOutrosVisiveis(1);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Suplementos"
                  type="text"
                  value={saudeOutros2Desc}
                  onChange={(e) => setSaudeOutros2Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Valor (2)
                </label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="100,00"
                      type="text"
                      value={saudeOutros2Valor}
                      onChange={(e) =>
                        setSaudeOutros2Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={saudeOutros2Freq}
                    onChange={(e) =>
                      setSaudeOutros2Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {saudeOutros2Valor &&
                  sanitizeBrlValue(saudeOutros2Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(sanitizeBrlValue(saudeOutros2Valor) / saudeOutros2Freq)
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          <div className="col-span-2">
            <button
              type="button"
              onClick={() =>
                setSaudeOutrosVisiveis((prev) => Math.min(prev + 1, 2))
              }
              className="text-primary text-sm hover:underline disabled:text-gray-400 disabled:no-underline"
              disabled={saudeOutrosVisiveis >= 2}
            >
              + Adicionar outro gasto de saúde
            </button>
          </div>

          {/* CATEGORIA: ALIMENTAÇÃO */}
          <div className="col-span-2 mt-6 mb-3 border-t pt-6">
            <h3 className="font-semibold text-lg text-primary flex items-center">
              Alimentação
              <span className="ml-2 text-xs bg-red-100 text-red-800 px-2 py-1 rounded font-normal">
                Essencial
              </span>
            </h3>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="alimentacao-supermercado"
            >
              <Tooltip text="Média mensal. Se varia, use a média dos últimos 3 meses">
                <span className="cursor-help border-b border-dotted border-gray-400">
                  Supermercado
                </span>
              </Tooltip>
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="alimentacao-supermercado"
                placeholder="800,00"
                type="text"
                value={alimentacaoSupermercado}
                onChange={(e) =>
                  setAlimentacaoSupermercado(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="alimentacao-delivery"
            >
              Delivery/Restaurantes
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="alimentacao-delivery"
                placeholder="300,00"
                type="text"
                value={alimentacaoDelivery}
                onChange={(e) =>
                  setAlimentacaoDelivery(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="alimentacao-feira"
            >
              Feira/Açougue
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="alimentacao-feira"
                placeholder="200,00"
                type="text"
                value={alimentacaoFeira}
                onChange={(e) =>
                  setAlimentacaoFeira(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          {/* Campo personalizado Alimentação */}
          {alimentacaoOutrosVisiveis >= 1 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-3 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setAlimentacaoOutros1Desc("");
                    setAlimentacaoOutros1Valor("");
                    setAlimentacaoOutros1Freq(1);
                    setAlimentacaoOutrosVisiveis(0);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Lanche no trabalho"
                  type="text"
                  value={alimentacaoOutros1Desc}
                  onChange={(e) => setAlimentacaoOutros1Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">Valor</label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="150,00"
                      type="text"
                      value={alimentacaoOutros1Valor}
                      onChange={(e) =>
                        setAlimentacaoOutros1Valor(
                          formatBrlInput(e.target.value),
                        )
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={alimentacaoOutros1Freq}
                    onChange={(e) =>
                      setAlimentacaoOutros1Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {alimentacaoOutros1Valor &&
                  sanitizeBrlValue(alimentacaoOutros1Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(alimentacaoOutros1Valor) /
                        alimentacaoOutros1Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          <div className="col-span-2">
            <button
              type="button"
              onClick={() =>
                setAlimentacaoOutrosVisiveis((prev) => Math.min(prev + 1, 1))
              }
              className="text-primary text-sm hover:underline disabled:text-gray-400 disabled:no-underline"
              disabled={alimentacaoOutrosVisiveis >= 1}
            >
              + Adicionar outro gasto de alimentação
            </button>
          </div>

          {/* CATEGORIA: ESTILO DE VIDA */}
          <div className="col-span-2 mt-6 mb-3 border-t pt-6">
            <h3 className="font-semibold text-lg text-primary flex items-center">
              Estilo de Vida
              <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded font-normal">
                Negociável
              </span>
            </h3>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-celular"
            >
              Celular/Telefonia
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-celular"
                placeholder="80,00"
                type="text"
                value={estiloCelular}
                onChange={(e) =>
                  setEstiloCelular(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-streaming"
            >
              Streaming (Netflix, Spotify, etc.)
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-streaming"
                placeholder="50,00"
                type="text"
                value={estiloStreaming}
                onChange={(e) =>
                  setEstiloStreaming(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-educacao"
            >
              Educação dos filhos
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-educacao"
                placeholder="800,00"
                type="text"
                value={estiloEducacaoFilhos}
                onChange={(e) =>
                  setEstiloEducacaoFilhos(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-pets"
            >
              Animais de estimação
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-pets"
                placeholder="150,00"
                type="text"
                value={estiloPets}
                onChange={(e) => setEstiloPets(formatBrlInput(e.target.value))}
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-faxina"
            >
              Faxina/Diarista
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-faxina"
                placeholder="300,00"
                type="text"
                value={estiloFaxina}
                onChange={(e) =>
                  setEstiloFaxina(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-jardinagem"
            >
              Jardinagem/Piscina
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-jardinagem"
                placeholder="200,00"
                type="text"
                value={estiloJardinagem}
                onChange={(e) =>
                  setEstiloJardinagem(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-salao"
            >
              Salão/Barbearia
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-salao"
                placeholder="100,00"
                type="text"
                value={estiloSalao}
                onChange={(e) => setEstiloSalao(formatBrlInput(e.target.value))}
              />
            </div>
          </div>

          <div className="sm:col-span-1 col-span-2">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="estilo-produtos"
            >
              Produtos de higiene/beleza
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="estilo-produtos"
                placeholder="150,00"
                type="text"
                value={estiloProdutos}
                onChange={(e) =>
                  setEstiloProdutos(formatBrlInput(e.target.value))
                }
              />
            </div>
          </div>

          {/* Campos personalizados Estilo de Vida */}
          {estiloOutrosVisiveis >= 1 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-3 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setEstiloOutros1Desc("");
                    setEstiloOutros1Valor("");
                    setEstiloOutros1Freq(1);
                    setEstiloOutrosVisiveis(0);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Assinaturas digitais"
                  type="text"
                  value={estiloOutros1Desc}
                  onChange={(e) => setEstiloOutros1Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">Valor</label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="100,00"
                      type="text"
                      value={estiloOutros1Valor}
                      onChange={(e) =>
                        setEstiloOutros1Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={estiloOutros1Freq}
                    onChange={(e) =>
                      setEstiloOutros1Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {estiloOutros1Valor &&
                  sanitizeBrlValue(estiloOutros1Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(estiloOutros1Valor) / estiloOutros1Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          {estiloOutrosVisiveis >= 2 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-4 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado 2
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setEstiloOutros2Desc("");
                    setEstiloOutros2Valor("");
                    setEstiloOutros2Freq(1);
                    setEstiloOutrosVisiveis(1);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Cursos online"
                  type="text"
                  value={estiloOutros2Desc}
                  onChange={(e) => setEstiloOutros2Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Valor (2)
                </label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="150,00"
                      type="text"
                      value={estiloOutros2Valor}
                      onChange={(e) =>
                        setEstiloOutros2Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={estiloOutros2Freq}
                    onChange={(e) =>
                      setEstiloOutros2Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {estiloOutros2Valor &&
                  sanitizeBrlValue(estiloOutros2Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(estiloOutros2Valor) / estiloOutros2Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          {estiloOutrosVisiveis >= 3 && (
            <>
              <div className="col-span-2 flex justify-between items-center mt-4 mb-2 pb-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Gasto Personalizado 3
                </h4>
                <button
                  type="button"
                  onClick={() => {
                    setEstiloOutros3Desc("");
                    setEstiloOutros3Valor("");
                    setEstiloOutros3Freq(1);
                    setEstiloOutrosVisiveis(2);
                  }}
                  className="text-red-600 hover:text-red-800 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors"
                  title="Remover este campo"
                >
                  ✕ Remover
                </button>
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Descrição
                </label>
                <input
                  className="w-full p-2 border rounded"
                  placeholder="Ex: Hobbies"
                  type="text"
                  value={estiloOutros3Desc}
                  onChange={(e) => setEstiloOutros3Desc(e.target.value)}
                />
              </div>
              <div className="sm:col-span-1 col-span-2">
                <label className="block mb-2 font-medium text-sm">
                  Valor (3)
                </label>
                <div className="flex gap-2">
                  <div className="flex border flex-1 max-w-[180px] sm:max-w-none">
                    <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                      R$
                    </span>
                    <input
                      className="flex-1 p-2 min-w-[60px]"
                      placeholder="200,00"
                      type="text"
                      value={estiloOutros3Valor}
                      onChange={(e) =>
                        setEstiloOutros3Valor(formatBrlInput(e.target.value))
                      }
                    />
                  </div>
                  <select
                    className="border p-2 rounded text-sm bg-white min-w-[140px]"
                    value={estiloOutros3Freq}
                    onChange={(e) =>
                      setEstiloOutros3Freq(Number(e.target.value))
                    }
                  >
                    <option value="1">Mensal</option>
                    <option value="2">A cada 2 meses</option>
                    <option value="3">A cada 3 meses</option>
                    <option value="6">A cada 6 meses</option>
                    <option value="12">Anual</option>
                  </select>
                </div>
                {estiloOutros3Valor &&
                  sanitizeBrlValue(estiloOutros3Valor) > 0 && (
                    <p className="text-xs text-gray-600 mt-1">
                      → R${" "}
                      {(
                        sanitizeBrlValue(estiloOutros3Valor) / estiloOutros3Freq
                      )
                        .toFixed(2)
                        .replace(".", ",")}{" "}
                      por mês
                    </p>
                  )}
              </div>
            </>
          )}

          <div className="col-span-2 mb-4">
            <button
              type="button"
              onClick={() =>
                setEstiloOutrosVisiveis((prev) => Math.min(prev + 1, 3))
              }
              className="text-primary text-sm hover:underline disabled:text-gray-400 disabled:no-underline"
              disabled={estiloOutrosVisiveis >= 3}
            >
              + Adicionar outro gasto de estilo de vida
            </button>
          </div>
        </MainCardContent>

        <div className="flex justify-between mt-6">
          <Button
            disabled={false}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <Button onClick={clear} variant={"ghost"}>
            Limpar
          </Button>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
